module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms02.8514b5aedf9d803adb20f4bd870ff1be.png";